const RoundedBorderButton = (props) => {
    return (
        <button onClick={props.onClick} className='flex-1 w-full border border-accent rounded-[6.25rem]' style={{ height: props.height }}>
            <p className='font-montserrat text-accent' style={{ fontWeight: props.fontWeight }}>{props.text}</p>
        </button>
    )
}

export default RoundedBorderButton